import React from 'react';
import { Button, Image, Modal } from 'react-bootstrap';
import qrCode from '../../Images/qrCode.png';
import './AccessCard.css';

const AccessCard = ({ image, title, description, input }) => {
  return (
    <div className="access-card">
      <Image src={image} alt={title} className="card-image" />
      <div className="access-card-body">
        <h3>{title}</h3>
        <p>{description}</p>
        {input}
      </div>
    </div>
  );
}

export default AccessCard;
